import React, { useEffect, useState } from 'react'
import grupo_1072 from '../../images/homePage/Grupo_1072.png'
import CandidateCard from '../../components/profiles/candidateCard/CandidateCard'
import { candidateEnglish, candidateFrance } from '../../firebase/data'
import { useLocation, useNavigate } from 'react-router-dom'
import irgtLogo from '../../images/logo-CS-horizontal_white-TM.png'
import ArrowRightButton from '../../common/ArrowRightButton'
import ArrowLeftButton from '../../common/ArrowLeftButton'
import './ProfilePage.css'
import { DICTIONARY } from '../../utilities/dictionary'
import { logEvent } from 'firebase/analytics'
import { analytics } from '../../firebase/firebaseConfig'
import { registerLogEvent } from '../../firebase/endpoints'
import { EventsName } from '../../models/events.models'

const ProfilesPage: React.FC = () => {
    // React Hooks
    const location = useLocation();
    const navigate = useNavigate();


    // States
    const [candidateProfile, setCandidateProfile] = useState<any>();
    const [counterProfile, setCounterProfile] = useState<string>("1");

    const previousPage = () => {
        if (location.pathname === '/en/profiles/1') {
            navigate("/en/process");
        } else if (location.pathname === '/en/profiles/2') {
            navigate("/en/profiles/1");
        } else if (location.pathname === '/en/profiles/3') {
            navigate("/en/profiles/2");
        } else if (location.pathname === '/fr/profiles/1') {
            navigate("/fr/process");
        } else if (location.pathname === '/fr/profiles/2') {
            navigate("/fr/profiles/1");
        } else if (location.pathname === '/fr/profiles/3') {
            navigate("/fr/profiles/2");
        }
    }

    const nextPage = () => {
        if (location.pathname === '/en/profiles/1') {
            navigate("/en/profiles/2");
        } else if (location.pathname === '/en/profiles/2') {
            navigate("/en/profiles/3");
        } else if (location.pathname === '/en/profiles/3') {
            navigate("/en/prices");
        } else if (location.pathname === '/fr/profiles/1') {
            navigate("/fr/profiles/2");
        } else if (location.pathname === '/fr/profiles/2') {
            navigate("/fr/profiles/3");
        } else if (location.pathname === '/fr/profiles/3') {
            navigate("/fr/prices");
        }
    }

    // Effects
    useEffect(() => {
        console.log(candidateEnglish)
        if (location.pathname === '/en/profiles/1') {
            setCandidateProfile(candidateEnglish[0]);
            logEvent(analytics, 'view_item', { viewName: "profile_english_1_page" });
        } else if (location.pathname === '/fr/profiles/1') {
            setCandidateProfile(candidateFrance[0]);
            logEvent(analytics, 'view_item', { viewName: "profile_french_1_page" });
        } else if (location.pathname === '/en/profiles/2') {
            setCandidateProfile(candidateEnglish[1]);
            logEvent(analytics, 'view_item', { viewName: "profile_english_2_page" });
        } else if (location.pathname === '/fr/profiles/2') {
            setCandidateProfile(candidateFrance[1]);
            logEvent(analytics, 'view_item', { viewName: "profile_french_2_page" });
        } else if (location.pathname === '/en/profiles/3') {
            setCandidateProfile(candidateEnglish[2]);
            logEvent(analytics, 'view_item', { viewName: "profile_english_3_page" });
        } else if (location.pathname === '/fr/profiles/3') {
            setCandidateProfile(candidateFrance[2]);
            logEvent(analytics, 'view_item', { viewName: "profile_french_3_page" });
        }
        const path = location.pathname;
        const segments = path.split('/'); // Esto divide la cadena en un array por cada '/'
        const lastSegment = segments.pop();
        setCounterProfile(lastSegment ? lastSegment : "1")
    }, [location.pathname]);

    // Effects
    useEffect(() => {
        registerLogEvent('view_item', { view_name: EventsName.PROCCESSPAGE, language: location.pathname === '/en/proccess' ? 'English' : 'French' })
        const startTime = Date.now();
        if (location.pathname === '/en/process') {
            registerLogEvent('navigate', { view_name: EventsName.PROCCESSPAGE, language: 'English' })

        } else if (location.pathname === '/fr/process') {
            registerLogEvent('navigate', { view_name: EventsName.PROCCESSPAGE, language: 'French' })
        }

        return () => {
            const duration = Date.now() - startTime;

            if (location.pathname === '/en/process') {
                registerLogEvent('view_duration', { view_name: EventsName.PROCCESSPAGE, duration, language: 'English' })

            } else if (location.pathname === '/fr/process') {
                registerLogEvent('view_duration', { view_name: EventsName.PROCCESSPAGE, duration, language: 'French' })
            }
        };
    }, [location.pathname]);
    return (
        <div style={{ height: '100vh', width: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div>
                <div>
                    <svg className="Rectngulo_153_r">
                        <radialGradient id="Rectngulo_153_r" spreadMethod="pad" x1="0" x2="0" y1="0" y2="0">
                            <stop offset="0" stopColor="#e3c9ff" stopOpacity="1"></stop>
                            <stop offset="0.1105" stopColor="#dfbffe" stopOpacity="1"></stop>
                            <stop offset="0.2936" stopColor="#d4a6fd" stopOpacity="1"></stop>
                            <stop offset="0.5266" stopColor="#c37dfc" stopOpacity="1"></stop>
                            <stop offset="0.7976" stopColor="#ac44f9" stopOpacity="1"></stop>
                            <stop offset="1" stopColor="#9916f8" stopOpacity="1"></stop>
                        </radialGradient>
                        <rect id="Rectngulo_153_r" rx="0" ry="0" x="0" y="0" width="100%" height="100%">
                        </rect>
                    </svg>
                </div>
                <div id="OBJECTS">
                    <div id="Grupo_1073">
                        <img id="Grupo_1072" src={grupo_1072} alt="Grupo 1072" />
                    </div>
                </div>
            </div>


            <div className="card-container">
                <div style={{ height: "100%", width: '100%', backgroundColor: 'white', borderTopLeftRadius: 65, borderBottomRightRadius: 65, padding: 2 }}>
                    <div style={{ width: '100%', height: '10%', backgroundColor: '#2D2E71', borderTopLeftRadius: 65, paddingRight: '50px', paddingLeft: '50px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span style={{ fontFamily: "Roboto", fontSize: 'calc(2vw + 4px)', color: 'white', fontWeight: 'bold' }}>
                            {
                                location.pathname.split('/')[1] === 'en' ? (
                                    location.pathname.split('/')[3] === '1' ? (
                                        DICTIONARY['profile_page_title_1']['English']
                                    ) : location.pathname.split('/')[3] === '2' ? (
                                        DICTIONARY['profile_page_title_2']['English']
                                    ) : location.pathname.split('/')[3] === '3' && (
                                        DICTIONARY['profile_page_title_3']['English']
                                    )
                                ) : location.pathname.split('/')[1] === 'fr' && (
                                    location.pathname.split('/')[3] === '1' ? (
                                        DICTIONARY['profile_page_title_1']['French']
                                    ) : location.pathname.split('/')[3] === '2' ? (
                                        DICTIONARY['profile_page_title_2']['French']
                                    ) : location.pathname.split('/')[3] === '3' && (
                                        DICTIONARY['profile_page_title_3']['French']
                                    )
                                )
                            }
                        </span>
                        <img alt={irgtLogo} src={irgtLogo} style={{ width: '270px', height: 'auto' }} />
                    </div>

                    <div style={{ height: "90%", paddingLeft: '50px', position: 'relative' }}>
                        <div style={{
                            position: 'absolute',
                            top: '20px',
                            backgroundColor: '#2D2E71',
                            height: '50px',
                            width: '80px',
                            right: '40px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: 25
                        }}>
                            <span style={{ color: 'white', fontSize: '30px', fontFamily: 'Roboto', fontWeight: 'bold' }}>{counterProfile}/3</span>
                        </div>
                        {
                            candidateProfile && (
                                <CandidateCard
                                    educationListForm={candidateProfile.education}
                                    experienceListForm={candidateProfile.experience}
                                    skillListForm={candidateProfile.skills}
                                />
                            )
                        }
                    </div>
                </div>
            </div>

            <ArrowLeftButton onClickFunction={previousPage} />
            <ArrowRightButton onClickFunction={nextPage} />
        </div >
    )
}

export default ProfilesPage
